import {
  GET_PROTOCOLS_TYPES,
  GET_PROTOCOLS_TYPES_SUCCESS,
  GET_PROTOCOLS_TYPES_FAILURE,
  GET_PROTOCOLS,
  GET_PROTOCOLS_SUCCESS,
  GET_PROTOCOLS_FAILURE,
  CREATE_PROTOCOLS,
  CREATE_PROTOCOLS_SUCCESS,
  CREATE_PROTOCOLS_FAILURE,
  DELETE_PROTOCOLS_REQUEST,
  DELETE_PROTOCOLS_SUCCESS,
  DELETE_PROTOCOLS_FAILURE,
  RETRY_PROTOCOL_CONVERSION,
  RETRY_PROTOCOL_CONVERSION_SUCCESS,
  RETRY_PROTOCOL_CONVERSION_FAILURE,
} from "../types/protocols.types";

const initialState = {
  protocols: null,
  error: "",
  loading: false,
};

const ProtocolReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROTOCOLS:
      return {
        ...state,
        loading: true,
      };
    case GET_PROTOCOLS_SUCCESS:
      return {
        ...state,
        loading: false,
        protocols: action.payload,
      };
    case GET_PROTOCOLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default ProtocolReducer;

const initialPostState = {
  protocolData: [],
  error: "",
  loading: false,
};

export const CreateProtocolReducer = (state = initialPostState, action) => {
  switch (action.type) {
    case CREATE_PROTOCOLS:
      return {
        ...state,
        loading: true,
      };
    case CREATE_PROTOCOLS_SUCCESS:
      return {
        ...state,
        loading: false,
        protocolData: action.payload,
      };
    case CREATE_PROTOCOLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


const initialDeleteState = {
  deleteData: [],
  error: "",
  loading: false,
};

export const DeleteProtocolReducer = (state = initialDeleteState, action) => {
  switch (action.type) {
    case DELETE_PROTOCOLS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_PROTOCOLS_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteData: action.payload,
      };
    case DELETE_PROTOCOLS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};


const initialRetryState = {
  retryData: null,
  error: "",
  loading: false,
};

export const RetryProtocolConversionReducer = (state = initialRetryState, action) => {
  switch (action.type) {
    case RETRY_PROTOCOL_CONVERSION:
      return {
        ...state,
        loading: true,
      };
    case RETRY_PROTOCOL_CONVERSION_SUCCESS:
      return {
        ...state,
        loading: false,
        retryData: action.payload,
      };
    case RETRY_PROTOCOL_CONVERSION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};